import api, { ValidateAxiosError } from '@/modules/api.service';
import { CreatePapelDto, ReadPapelDto, UpdatePapelDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindPapelDto, InsertPapelResult } from '@/api.types.extra';

const endpoint = Endpoints.PAPEL;

export async function createPapel(dto: CreatePapelDto) {
  try {
    const response = await api.post<InsertPapelResult>(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a papel.');
  }
}

export async function readPapel(skip: number, take: number, id?: number) {
  const filters: FindPapelDto = {
    skip: skip ?? 0,
    take: take ?? 100,
    // Para listagem, não precisa carregar todos os relacionamentos
    // Apenas carrega quando é edição (id presente)
    comPermissoes: !!id,
    comUsuarios: !!id,
    id: id
  }

  try {
    const response = await api.get<[ReadPapelDto[], number]>(Endpoints.PAPEL, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar papel.');
  }
}

// Função otimizada para listagem - carrega apenas contagem de usuários
export async function readPapelListagem(skip: number, take: number, orderBy?: string, orderField?: string) {
  const filters: FindPapelDto = {
    skip: skip ?? 0,
    take: take ?? 100,
    comPermissoes: false,
    comUsuarios: true,
    // @ts-expect-error types.
    orderBy: orderBy as "ASC" | "DESC" | undefined,
    orderField: orderField
  }

  try {
    const response = await api.get<[ReadPapelDto[], number]>(Endpoints.PAPEL, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar papel.');
  }
}

export async function updatePapel(dto: UpdatePapelDto, id: number) {
  try {
    const response = await api.put<InsertPapelResult>(endpoint + '/' + id, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a papel.');
  }
}

export async function deletePapel(id: number) {
  try {
    const response = await api.delete<InsertPapelResult>(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a papel.');
  }
}